export default {
  type: "FeatureCollection",
  name: "ContornoCba",
  crs: { type: "name", properties: { name: "urn:ogc:def:crs:OGC:1.3:CRS84" } },
  features: [
    {
      type: "Feature",
      properties: { id: null },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-64.963657170941445, -29.596466125813787],
              [-64.81763368249608, -29.573586869559691],
              [-64.275933644714897, -29.499565746384622],
              [-63.981194990617809, -29.550707613305576],
              [-63.956969895760508, -29.623382897877462],
              [-63.93543647810958, -29.624728736480648],
              [-63.874873740966343, -29.63011209089338],
              [-63.868144547950429, -29.615307866258366],
              [-63.85872367772815, -29.601849480226534],
              [-63.8385360986804, -29.583007739781973],
              [-63.812965165219921, -29.576278546766055],
              [-63.784702554553078, -29.587045255591519],
              [-63.786048393156264, -29.593774448607437],
              [-63.794123424775357, -29.604541157432902],
              [-63.79546926337855, -29.615307866258373],
              [-63.760477459695785, -29.622037059274287],
              [-63.748364912267142, -29.632803768099752],
              [-63.749710750870321, -29.642224638322034],
              [-63.744327396457592, -29.654337185750681],
              [-63.722793978806664, -29.666449733179327],
              [-63.714718947187563, -29.662412217369781],
              [-63.683764659314356, -29.663758055972963],
              [-63.668960434679342, -29.662412217369781],
              [-63.650118694234777, -29.662412217369781],
              [-63.631276953790213, -29.655683024353863],
              [-63.60705185893292, -29.662412217369781],
              [-63.581480925472441, -29.659720540163413],
              [-63.565330862234241, -29.663758055972963],
              [-63.549180798996048, -29.661066378766595],
              [-63.530339058551483, -29.654337185750681],
              [-63.465738805598697, -29.663758055972963],
              [-63.48188886883689, -29.727012470322567],
              [-63.460355451185961, -29.727012470322567],
              [-63.460355451185961, -29.75527508098941],
              [-62.806277890038992, -29.834679558577211],
              [-62.822427953277185, -29.841408751593125],
              [-62.834540500705835, -29.857558814831322],
              [-62.837232177912199, -29.873708878069518],
              [-62.82781130768992, -29.876400555275886],
              [-62.822427953277185, -29.900625650133179],
              [-62.802240374229441, -29.908700681752279],
              [-62.798202858419891, -29.923504906387294],
              [-62.784744472388063, -29.942346646831854],
              [-62.791473665403977, -29.953113355657322],
              [-62.790127826800791, -29.961188387276419],
              [-62.75648186172122, -29.965225903085969],
              [-62.724181735244819, -29.99214267514964],
              [-62.699956640387526, -29.989450997943276],
              [-62.691881608768426, -29.996180190959191],
              [-62.663618998101583, -29.997526029562373],
              [-62.658235643688855, -30.008292738387837],
              [-62.673039868323869, -30.035209510451498],
              [-62.654198127879305, -30.054051250896062],
              [-62.620552162799726, -30.05270541229288],
              [-62.607093776767897, -30.059434605308795],
              [-62.588252036323333, -30.060780443911977],
              [-62.574793650291504, -30.062126282515159],
              [-62.557297748450125, -30.063472121118345],
              [-62.564026941466039, -30.087697215975638],
              [-62.561335264259668, -30.099809763404288],
              [-62.569410295878768, -30.125380696864767],
              [-62.592289552132883, -30.163064177753892],
              [-62.592289552132883, -30.177868402388906],
              [-62.599018745148797, -30.191326788420735],
              [-62.592289552132883, -30.223626914897128],
              [-62.594981229339247, -30.264002072992614],
              [-62.538456008005561, -30.309760585500836],
              [-62.524997621973732, -30.336677357564501],
              [-62.175079585146129, -30.344752389183597],
              [-62.132012749844272, -30.476644572295537],
              [-61.841311611556741, -30.745812292932154],
              [-62.123937718225179, -31.603111483159779],
              [-62.239679838098922, -31.700011862588962],
              [-62.218146420447994, -31.740387020684452],
              [-62.218146420448001, -31.786145533192677],
              [-62.227567290670287, -31.833249884304085],
              [-62.223529774860737, -31.884391751225042],
              [-62.187192132574793, -31.923421070717353],
              [-62.167004553527043, -31.983983807860589],
              [-62.180462939558879, -32.047238222210197],
              [-62.180462939558879, -32.060696608242026],
              [-62.197958841400258, -32.111838475162983],
              [-62.179117100955693, -32.158942826274391],
              [-62.133358588447472, -32.203355500179427],
              [-62.102404300574257, -32.220851402020813],
              [-62.037804047621471, -32.262572398719485],
              [-62.013578952764178, -32.34466855351365],
              [-61.985989261398906, -32.38437079230755],
              [-61.983970503494135, -32.393791662529829],
              [-61.972530875367077, -32.404558371355293],
              [-61.967147520954342, -32.415325080180757],
              [-61.958399570033656, -32.4200355152919],
              [-61.946959941906599, -32.434839739926915],
              [-61.936866152382727, -32.453681480371472],
              [-61.911968138223841, -32.496075396371744],
              [-61.920043169842934, -32.505496266594022],
              [-61.913986896128613, -32.514917136816308],
              [-61.913986896128613, -32.524338007038587],
              [-61.932828636573177, -32.542506828181558],
              [-61.908603541715884, -32.553273537007023],
              [-61.903220187303148, -32.562694407229301],
              [-61.92138900844612, -32.579517389769094],
              [-61.92138900844612, -32.590957017896152],
              [-61.883032608255405, -32.594321614404102],
              [-61.926099443557263, -32.637388449705959],
              [-61.947632861208191, -32.664305221769624],
              [-61.915332734731798, -32.701988702658753],
              [-61.866882545017205, -32.696605348246017],
              [-61.834582418540812, -32.761205601198803],
              [-61.813049000889883, -32.761205601198803],
              [-61.775365520000761, -32.820422499738861],
              [-61.802282292064419, -32.879639398278918],
              [-61.76459881117529, -32.906556170342576],
              [-61.786132228826226, -32.955006360057169],
              [-61.791515583238954, -33.01422325859722],
              [-61.899182671493598, -33.111123638026406],
              [-61.920716089144527, -33.116506992439135],
              [-62.884336529023606, -34.381595279431224],
              [-63.384988489407711, -34.386978633843952],
              [-63.395755198233175, -35.006064391308165],
              [-65.102278547069304, -35.016831100133629],
              [-65.107661901482018, -33.913243445523506],
              [-65.14130786656159, -33.195911470026928],
              [-65.098241031259732, -33.156882150534621],
              [-65.079399290815161, -33.144769603105971],
              [-65.059211711767418, -33.119198669645492],
              [-65.055174195957861, -33.108431960820027],
              [-65.056520034561046, -33.100356929200927],
              [-65.043061648529218, -33.062673448311806],
              [-65.030949101100575, -33.054598416692706],
              [-65.014799037862375, -33.024989967422677],
              [-64.998648974624174, -33.000764872565384],
              [-65.020182392275103, -32.973848100501719],
              [-64.993265620211446, -32.946931328438062],
              [-64.993265620211446, -32.928089587993497],
              [-64.977115556973246, -32.911939524755297],
              [-64.977115556973246, -32.87694772107254],
              [-64.963657170941417, -32.855414303421611],
              [-64.969040525354146, -32.831189208564311],
              [-64.969040525354146, -32.801580759294289],
              [-64.950198784909588, -32.782739018849725],
              [-64.942123753290488, -32.766588955611525],
              [-64.947507107703217, -32.745055537960596],
              [-64.94481543049686, -32.720830443103303],
              [-64.920590335639559, -32.69660534824601],
              [-64.909823626814088, -32.68045528500781],
              [-64.923282012845931, -32.661613544563245],
              [-64.909823626814088, -32.637388449705952],
              [-64.917898658433188, -32.615855032055023],
              [-64.885598531956802, -32.572788196753166],
              [-64.885598531956802, -32.527029684244937],
              [-64.917898658433188, -32.481271171736715],
              [-64.915206981226831, -32.435512659228493],
              [-64.931357044465017, -32.427437627609393],
              [-64.923282012845931, -32.400520855545729],
              [-64.920590335639559, -32.3789874378948],
              [-64.925973690052288, -32.360145697450236],
              [-64.920590335639559, -32.327845570973842],
              [-64.942123753290488, -32.303620476116542],
              [-64.969040525354146, -32.317078862148371],
              [-64.993265620211446, -32.314387184942007],
              [-65.055174195957861, -32.317078862148371],
              [-65.208599796720733, -32.327845570973835],
              [-65.208599796720733, -32.306312153322907],
              [-65.219366505546191, -32.279395381259242],
              [-65.211291473927105, -32.263245318021049],
              [-65.211291473927105, -32.23363686875102],
              [-65.232824891578034, -32.214795128306456],
              [-65.224749859958933, -32.169036615798234],
              [-65.232824891578034, -32.152886552560034],
              [-65.246283277609862, -32.090977976813612],
              [-65.310883530562649, -32.04521946430539],
              [-65.628501440913851, -31.899868895161617],
              [-65.768468655644895, -31.889102186336153],
              [-65.768468655644895, -31.038532189124442],
              [-65.52621770707195, -30.497505070644849],
              [-65.422588134626864, -30.119324423150406],
              [-65.158803768402976, -30.047322057880109],
              [-64.93808623748096, -29.847465025307429],
              [-64.963657170941445, -29.596466125813787],
            ],
          ],
        ],
      },
    },
  ],
};
